import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=125644db&scoped=true&"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125644db",
  null
  
)

export default component.exports